import EMBER_LOTTIE from '@assets/EmberLogoAnim.json'
import EMBER_LOTTIE_THINKING from '@assets/EmberLogoAnimThinking.json'
import { Box } from '@chakra-ui/react'
import { Player } from '@lottiefiles/react-lottie-player'
import { type FC, useRef, useState } from 'react'

export const EmberAvatar: FC<{ size?: string; isThinking?: boolean; animated?: boolean }> = ({ size, isThinking, animated = false }) => {
  const playerRef = useRef<Player>(null)

  const [animationSrc, setAnimationSrc] = useState(isThinking ? EMBER_LOTTIE_THINKING : EMBER_LOTTIE)
  const [hovered, setHovered] = useState(false)

  const handleMouseEnter = () => {
    if (!animated) return
    setHovered(true)
    setAnimationSrc(EMBER_LOTTIE_THINKING)
  }

  const handleMouseLeave = () => {
    if (!animated) return
    setHovered(false)
    setAnimationSrc(EMBER_LOTTIE)
  }

  // Deactive for now as it leads infinite bugs in components during the first loop of the animation. It only happens in Chrome.
  // TODO: Investigate if updating the player could fix the issue.
  // useEffect(() => {
  //   // Added a timeout to start the animation after 1 second to avoid infinite re-render bug in the lottie player. Cause of the bug is unknown.
  //   // possible explanation: immediately calling playerRef.current.play() might cause a re-render loop due to some internal state or prop changes within the Lottie player component
  //   let timeout
  //   if (playerRef.current) {
  //     timeout = setTimeout(() => {
  //       console.log('Starting Lottie animation')
  //       playerRef.current?.play()
  //     }, 1000)
  //   }
  //   return timeout ? () => clearTimeout(timeout) : undefined
  // }, [playerRef.current])

  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Player
        speed={isThinking ? 1.5 : undefined}
        src={isThinking ? EMBER_LOTTIE_THINKING : animationSrc}
        className={`${hovered ? 'player-hover' : 'player'}`}
        ref={playerRef}
        loop
        id='lottiePlayer'
        style={{ height: size ? size : '44px', width: size ? size : '44px' }}
      />
    </Box>
  )
}
